const setSlides = (state, slides) => {
  state.slides = slides;
};

const setArchSlides = (state, slides) => {
  state.archSlides = slides;
};

const setFeatSlides = (state, slides) => {
  state.featSlides = slides;
};

const setSuiteDetails = (state, obj) => {
  state.suiteDetails.cityscape = obj.cityscape;
  state.suiteDetails.sealoge = obj.sealoge;
  state.suiteDetails.skye = obj.skye;
  state.suiteDetails.summer = obj.summer;
};

export default {
  setSlides,
  setArchSlides,
  setFeatSlides,
  setSuiteDetails
};



// WEBPACK FOOTER //
// ./src/store/modules/amenities/mutations.js